import { is } from "@/lib/is/is";

export const ACTIONS = [
  "list",
  "get",
  "logs",
  "send",
  "pause",
  "resume",
  "kill",
  "archive",
  "checks",
  "pr",
  "verify",
] as const;

export const CONTROL_PATHS: Record<string, string> = {
  pause: "pause",
  resume: "resume",
  kill: "kill",
  archive: "archive",
};

export const STATUS_GROUPS = ["active", "waiting", "done"] as const;

export const SESSION_FIELDS = {
  id: is.string,
  title: is.string,
  status: is.string,
  taskType: is.string,
  repos: is.array,
  deliverables: is.array,
};
